/** @file toBabylonQuat: a z-up world quaternion as the Babylon quaternion of the swapped y/z frame. */
import { Quaternion } from '@babylonjs/core/Maths/math.vector.js';
import type { Quat } from '@zilo/pose3d-math/quat/quat';

/** `(x, y, z, w) -> (-x, -z, -y, w)`: the y/z swap is a reflection, so the axis is swapped and the angle flips. */
export function toBabylonQuat(q: Quat, out: Quaternion = new Quaternion()): Quaternion {
  return out.set(-q[0], -q[2], -q[1], q[3]);
}
